module.exports = __webpack_public_path__ + "media/images/front/icons/icon_cart-68a8bfc012b79846a69283f389d38dfc.svg";